// @flow

/**
 * It takes a string and return a new shorter version.
 * @param {string} str - string to shorten
 * @param {number} limit - limit the length of the string
 * @param {string} suffix - it can be added to the end of the string i.e. ellipsis: ...
 * @return {string} -
 */
const shortenStringWithSuffix = (
  str: string,
  limit: number,
  suffix: string = '...'
) => {
  if (typeof str === 'string') {
    if (str.length < limit) {
      return str;
    } else {
      const trimmedStr = str
        .trim()
        .substring(0, limit)
        .trim()
        .replace(/[,.]$/, '');
      return `${trimmedStr}${suffix}`;
    }
  }
};

export default shortenStringWithSuffix;



// WEBPACK FOOTER //
// ./src/utils/shortenStringWithSuffix/index.js